/* Cabana's Ranch - FREE Mystery Hat on $150+ orders (corregido 15 oct 2026) */
(function() {
  var HAT_VARIANT_ID = 46194641404039;
  var THRESHOLD_CENTS = 15000; // $150
  var FLAG = 'cr_hat_sync';

  function getCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function syncHat() {
    // Evita ciclos infinitos
    if (sessionStorage.getItem(FLAG)) return;

    getCart().then(function(cart) {
      var hatItem = null;
      var productsTotal = 0; // total SIN contar la gorra
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.variant_id === HAT_VARIANT_ID) {
          hatItem = item;
        } else {
          productsTotal += item.final_line_price;
        }
      }
      var qualifies = productsTotal >= THRESHOLD_CENTS;

      if (qualifies && !hatItem) {
        sessionStorage.setItem(FLAG, 'adding');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: HAT_VARIANT_ID, quantity: 1 })
        }).then(function() {
          sessionStorage.removeItem(FLAG);
          window.location.reload();
        }).catch(function() { sessionStorage.removeItem(FLAG); });
      } else if (!qualifies && hatItem) {
        sessionStorage.setItem(FLAG, 'removing');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: hatItem.key, quantity: 0 })
        }).then(function() {
          sessionStorage.removeItem(FLAG);
          window.location.reload();
        }).catch(function() { sessionStorage.removeItem(FLAG); });
      } else if (qualifies && hatItem && hatItem.quantity > 1) {
        // Solo una gorra gratis por pedido
        sessionStorage.setItem(FLAG, 'fixing');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: hatItem.key, quantity: 1 })
        }).then(function() {
          sessionStorage.removeItem(FLAG);
          window.location.reload();
        }).catch(function() { sessionStorage.removeItem(FLAG); });
      }
    }).catch(function(){});
  }

  // Revisa al cargar cada página
  function init() { setTimeout(syncHat, 500); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Revisa después de agregar, quitar, cambiar cantidades o vaciar el carro
  var CART_URLS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var origFetch = window.fetch;
  window.fetch = function(url, opts) {
    var p = origFetch.apply(this, arguments);
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    for (var i = 0; i < CART_URLS.length; i++) {
      if (urlStr.indexOf(CART_URLS[i]) !== -1) {
        p.then(function() { setTimeout(syncHat, 1200); }).catch(function(){});
        break;
      }
    }
    return p;
  };
})();
